import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { FeatureFlags } from '../../../ts/FeatureFlags';
import { DatasourceDefinition, ExplorableItemDefinitions, MixedContentItemDefinition } from '../../../ts/models/ContentDefinitions';
import { SITE_SPACE_EXPLORE, SiteSpaceContentType } from '../../state/SiteSpaceContentTypeState';
import { ExplorerDropdown } from '../Components/ExplorerDropdown';
import { ExplorerFlyoutPanelProps } from '../Components/ExplorerFlyoutPanel';
import { ExplorerStyles } from '../Explorer/ExplorerStyles';
import { ConnectedSiteLevelFilterMenu } from './ConnectedSiteLevelFilterMenu';

export interface SiteLevelFilterByTypeDropdownProps {
  readonly changeCurrentContentType: (selectedContentType: SiteSpaceContentType) => void;
  readonly currentContentType: SiteSpaceContentType;
}

export class SiteLevelFilterByTypeDropdown extends React.PureComponent<SiteLevelFilterByTypeDropdownProps> {
  public render(): JSX.Element {
    return (
      <ExplorerDropdown
        buttonTitle={''}
        testId={SiteLevelFilterByTypeDropdownTestIds.dropdown}
        renderButtonContent={this.renderButtonContent}
        renderPanel={this.renderPanel}
        panelTitle={Messages.siteFilterByTypeDropdown_PanelTitle()}
      />
    );
  }

  private renderPanel = (props: ExplorerFlyoutPanelProps): JSX.Element => {
    return (
      <ConnectedSiteLevelFilterMenu
        onSelect={(value: SiteSpaceContentType) => {
          props.onCloseRequest();
          this.handleSelection(value);
        }}
        anchorEl={props.anchorEl}
        testId={props.testId}
        onCloseRequest={props.onCloseRequest}
      />
    );
  }

  private renderButtonContent = (): JSX.Element => {
    return <span className={ExplorerStyles.SiteSpaceContentFilterButton}>{this.getButtonText()}</span>;
  }

  private getButtonText = (): string => {
    if (this.props.currentContentType === 'dataconnection') {
      return DatasourceDefinition.siteFilterByTypeDropdownName();
    } else if (this.props.currentContentType === SITE_SPACE_EXPLORE) {
      return Messages.siteFilterByTypeDropdown_TopLevelProjects();
    } else {
      return (ExplorableItemDefinitions[this.props.currentContentType] as MixedContentItemDefinition).siteFilterByTypeDropdownName();
    }
  }

  private handleSelection = (value: SiteSpaceContentType) => {
    this.props.changeCurrentContentType(value);
  }
}

export namespace SiteLevelFilterByTypeDropdownTestIds {
  export const dropdown = 'site-filter-by';
  export const item = 'site-filter-by';
}
